/* localDate.js */

"use strict";

/**
 * The browser's local day/month/year order, so dates parse the same way they're displayed.
 * @returns {string[]}
 */
function getLocalDatePartOrder() {
    return new Intl.DateTimeFormat(undefined, {year: "numeric", month: "2-digit", day: "2-digit"})
        .formatToParts(new Date())
        .filter((part) => part.type === "day" || part.type === "month" || part.type === "year")
        .map((part) => part.type);
}

/**
 * Parse a date string written in the browser's local format using its own local part order.
 * @param {string} value
 * @returns {?Date} - local midnight on the parsed date, or null if unparseable/invalid
 */
function parseLocalDate(value) {
    const tokens = String(value).match(/\d+/g);
    if (!tokens || tokens.length !== 3) {
        return null;
    }

    const parts = {};
    getLocalDatePartOrder().forEach((type, idx) => {
        parts[type] = parseInt(tokens[idx], 10);
    });
    const {day, month} = parts;
    let {year} = parts;
    if (!day || !month || !year) {
        return null;
    }
    if (year < 100) {
        year += 2000;
    }

    const date = new Date(year, month - 1, day);
    const isValidCalendarDate =
        date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
    return isValidCalendarDate ? date : null;
}

/**
 * The Unix timestamp for 12:00 PM UTC on the given calendar date.
 * @param {Date} date
 * @returns {number}
 */
function toUTCMidDayTimestamp(date) {
    return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0, 0);
}

module.exports = {
    getLocalDatePartOrder,
    parseLocalDate,
    toUTCMidDayTimestamp,
};
